/*
 * Copyright 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {CommonModule} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ngfModule} from 'angular-file';
import {ClearAllDialogComponent} from '../onboarding/clear-all-dialog/clear-all-dialog.component';
import {ErrorComponent} from './error/error.component';
import {ItemComponent} from './item/item.component';
import {MaterialModule} from './material.module';
import {SnackbarComponent} from './snackbar/snackbar.component';
import {XmlExportComponent} from './xml-export/xml-export.component';

@NgModule({
    exports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        ngfModule,
        ErrorComponent,
        ItemComponent,
        XmlExportComponent,
    ], imports: [CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        ngfModule,
        // Not exporting RouterModule as the routing modules do that already
        RouterModule, ErrorComponent,
        ItemComponent,
        XmlExportComponent,
        SnackbarComponent,
        ClearAllDialogComponent], providers: [
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })

export class SharedModule {
}
